'use client';

import { formatDayKey } from '@/app/[locale]/event/[eventId]/libs/matchesDay';

/**
 * A day chip's label. Node and the browser abbreviate weekdays and months differently (ICU), so
 * the server HTML and the first client render can disagree on this string; suppressHydrationWarning
 * keeps that from throwing React #418 (the old DaySelector did the same).
 */
export function DayChipLabel({ dayKey, locale }: { dayKey: string; locale: string }) {
  return <span suppressHydrationWarning>{formatDayKey(dayKey, locale)}</span>;
}
